import { Injectable } from '@angular/core';

export const filtersParams = [
    { field: 'candidateName', operator: 'contains' },
    { field: 'facilityName', operator: 'contains' },
    { field: 'agencyName', operator: 'contains' },
    { field: 'expertise', operator: 'contains' },
    { field: 'profession', operator: 'eq' },
    { field: 'offerStatus', operator: 'eq' }
];

@Injectable({
    providedIn: 'root'
})
export class SharedOffersService {
    getFilterProps(
        props: { params: Record<string, unknown> },
        page: string
    ): Array<{ field: string; operator: string; value: unknown }> {
        const args: Array<{ field: string; operator: string; value: unknown }> = [];
        for (const [key, value] of Object.entries(props.params)) {
            if (key !== page && value) {
                if (key === filtersParams[4].field) {
                    if (typeof value === 'string') {
                        args.push({ field: key, operator: filtersParams[4].operator, value: parseInt(value, 10) });
                    } else {
                        args.push({ field: key, operator: filtersParams[4].operator, value });
                    }
                }
                if (key === filtersParams[5].field && value) {
                    args.push({
                        field: key,
                        operator: filtersParams[5].operator,
                        value: Array.isArray(value) ? value.map(Number) : parseInt(String(value), 10)
                    });
                }
                if (
                    key === filtersParams[0].field ||
                    key === filtersParams[1].field ||
                    key === filtersParams[2].field ||
                    (key === filtersParams[3].field && value)
                ) {
                    args.push({ field: key, operator: filtersParams[0].operator, value });
                }
            }
        }
        return args;
    }

    getContractEndDateSaturday(date: Date): Date {
        if (date instanceof Date) {
            const d = new Date(date);
            const dayWeekNumber = d.getDay();
            const dateNumber = d.getDate();
            if (dayWeekNumber <= 5) {
                //Sunday - Friday
                return new Date(d.setDate(dateNumber - dayWeekNumber - 1));
            }
        }

        return date;
    }

    getShiftEndTime(shiftLength: any, startTime: Date): Date {
        const result = new Date(startTime.getTime());
        const wholeHour = Math.floor(shiftLength);
        const wholeMin = shiftLength - wholeHour;
        result.setHours(startTime.getHours() + wholeHour);
        result.setMinutes(startTime.getMinutes() + (wholeMin === 0.5 ? 30 : 0));

        return result;
    }

    generateUrlTreeOffers(event: any, urlTree: any): any {
        urlTree.queryParams = {};
        urlTree.queryParams['perPage'] = event.take;
        urlTree.queryParams['hideContractRequested'] = true;
        urlTree.queryParams['hideDeclinedAndRescinded'] = true;
        urlTree.queryParams['byId'] = true;
        if (event.filter.filters.length) {
            event.filter.filters.forEach((elem: any) => {
                if (
                    elem.hasOwnProperty('field') &&
                    elem.field !== 'accountManagerId' &&
                    elem.field !== 'hideContractRequested' &&
                    elem.field !== 'hideDeclinedAndRescinded'
                ) {
                    urlTree.queryParams[elem.field] = elem.value;
                }
                if (elem.field === 'hideContractRequested') {
                    delete urlTree.queryParams['hideContractRequested'];
                }
                if (elem.field === 'hideDeclinedAndRescinded') {
                    delete urlTree.queryParams['hideDeclinedAndRescinded'];
                }
                if (elem.field === 'accountManagerId') {
                    delete urlTree.queryParams['byId'];
                }
                if (elem.filters) {
                    elem.filters.forEach((props: any) => {
                        if (
                            props.field !== 'hideContractRequested' &&
                            props.field !== 'hideDeclinedAndRescinded' &&
                            props.field !== 'accountManagerId'
                        ) {
                            urlTree.queryParams[props.field] = props.value;
                        }

                        if (props.field === 'hideContractRequested') {
                            delete urlTree.queryParams['hideContractRequested'];
                        }

                        if (props.field === 'hideDeclinedAndRescinded') {
                            delete urlTree.queryParams['hideDeclinedAndRescinded'];
                        }

                        if (props.field === 'accountManagerId') {
                            delete urlTree.queryParams['byId'];
                        }
                    });
                }
            });
        } else {
            filtersParams.forEach((param) => {
                delete urlTree.queryParams[param.field];
            });
        }
        return urlTree;
    }
}
